// The audited server export (DRILL-EXPORT-STANDARD rule 1): a sensitive list's CSV / Excel is made by the server from the
// screen's own read, with the person's own permission, and recorded in the audit trail. The browser only says which
// list, which columns (as on screen) and which rows (the keys left by the filter box, in the order shown).
import { ApiError, authHeaders, withBasis } from '../api';

export interface ServerExport {
  /** names the list in the audit trail ("receivables-by-dealer") */
  list: string;
  /** the screen's own read (GET), e.g. /api/v1/finance/payables */
  path: string;
  /** where the rows sit in its answer ("vendors", "group.parties"); '' for the answer itself */
  pick: string;
  /** the fields whose values, joined by "|", make a row's key on screen */
  key: string[];
  /** a column's field in the answer when it is not the column key */
  fields?: Record<string, string>;
}
export interface ServerColumn { title: string; field: string; kind: 'text' | 'money' | 'units' | 'pct' | 'date' | 'num'; perm?: string }

export async function serverExport(s: ServerExport, format: 'csv' | 'xlsx', body: { title: string; notes: string[]; columns: ServerColumn[]; keys?: string[] }): Promise<void> {
  const r = await fetch('/api/v1/export', { method: 'POST', credentials: 'same-origin', headers: { ...authHeaders(), 'content-type': 'application/json' }, body: JSON.stringify({ list: s.list, path: withBasis(s.path), pick: s.pick, key: s.key, keys: body.keys, columns: body.columns, format, title: body.title, notes: body.notes }) });
  if (!r.ok) { const e = await r.json().catch(() => ({})) as { error?: string; code?: string }; throw new ApiError(r.status, e.code, e.error ?? r.statusText); }
  const name = /filename="([^"]+)"/.exec(r.headers.get('content-disposition') ?? '')?.[1] ?? `leo-core-export.${format}`;
  const blob = await r.blob();
  try { const url = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 2000); } catch { /* downloads blocked */ }
}
